import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import { Box, Tooltip } from '@mui/material';
import { Home } from '@mui/icons-material';
import ImportarSalaSessaoLote from './ImportarSalaSessaoLote';
import ComposicaoEmLote from './ComposicaoEmLote';
import RascunhoCertidaoEmLote from './RascunhoCertidaoEmLote';
import MovimentoDecisaoLote from './MovimentoDecisaoLote';
import ToggleAtualizacaoInformacoesProcesso from './ToggleAtualizacaoInformacoesProcesso';
import ExportarRelatoriosProcessosFiltrados from './toolbar/ExportarRelatoriosProcessosFiltrados';
import AtualizarDecisaoLote from './AtualizarDecisaoLote';

export const ref = React.createRef();

class FerramentasListaProcessosPreSessao extends ReactComponent {
    openModalProcessosEmLote = false;

    search = (event) => {
        event.preventDefault();
        document.getElementById('numero').focus();
    };

    abrirModalProcessosEmLote = () => {
        this.openModalProcessosEmLote = true;
    };

    onCloseModalProcessosEmLotePJe = () => {
        this.openModalProcessosEmLote = false;
    };

    onCloseModalErrosEnvioLotePJe = () => {
        this.preSessaoStore.abrirMensagemErroLote = false;
    };

    handleClickHome = () => {
        this.preSessaoStore.posicionarProcessosEmExibicaoPeloIndice(0);
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            openModalProcessosEmLote: observable,
            search: action,
            abrirModalProcessosEmLote: action,
            onCloseModalProcessosEmLotePJe: action,
            onCloseModalErrosEnvioLotePJe: action,
            tituloTooltipEnviarProcessos: computed
        });
    }

    /**
     * Monta e retorna o título do botão "Enviar Processos".
     * @returns {string} O título do botão "Enviar Processos"
     */
    get tituloTooltipEnviarProcessos() {
        if (this.isComponenteHabilitado('EnvioAcordaoSIJ')) {
            if (this.preSessaoStore.isSessaoMista()) {
                return 'Enviar processos para o sistema de origem';
            }

            if (this.preSessaoStore.existeSessaoSIJ) {
                return 'Enviar processos para o eSIJ';
            }
        }

        return 'Enviar processos para o PJe';
    }

    render() {
        return (
            <Box
                id="divFerramentasListaProcessos"
                sx={{
                    display: 'flex',
                    margin: '0px 10px',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexGrow: '1',
                        justifyContent: 'space-between',
                        zIndex: '999',
                        margin: '2px 0px'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexGrow: '1',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start'
                        }}
                    >
                        <ToggleAtualizacaoInformacoesProcesso />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexGrow: '1',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            margin: '5px',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <div className="corBotao">
                            <Tooltip
                                title={'Ir para o início da página'}
                                placement="top-start"
                            >
                                <Home
                                    onClick={this.handleClickHome}
                                    style={{ marginRight: '10px', cursor: 'pointer' }}
                                />
                            </Tooltip>
                        </div>
                        {this.preSessaoStore.idProcessosEmExibicao === 'P' && (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-evenly',
                                    alignItems: 'center',
                                    zIndex: '999'
                                }}
                            >
                                <ImportarSalaSessaoLote />
                                <AtualizarDecisaoLote />
                            </div>
                        )}
                        <ComposicaoEmLote />
                        <MovimentoDecisaoLote />
                        <RascunhoCertidaoEmLote />
                        <ExportarRelatoriosProcessosFiltrados />
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                            <PainelFiltros />
                        </div>
                    </div>
                    <FiltroRapido id="filtroRapidoListaProcessos" />
                </div>
            </Box>
        );
    }
}

export default inject('stores')(observer(FerramentasListaProcessosPreSessao));
